module.exports = __webpack_public_path__ + "static/media/Program10.b2c67ec1.png";